import * as Sentry from '@sentry/nextjs'

/**
 * @param timeout in milliseconds
 * @returns A promise which resolves to true if the queue successfully drains before the timeout, or false if it doesn't (or if there's no client defined).
 */
export const flushSentry = (timeout: number = 2000) => {
  return Sentry.flush(timeout)
}

// ? the same function used with @sentry/browser in CRA project
/**
 * https://docs.sentry.io/platforms/node/configuration/draining/
 *
 * @param timeout in milliseconds
 * @returns promise that resolves when all pending events are flushed, or the timeout kicks in
 */
/* export const flushSentry = (timeout: number = 2000) => {
  const client = Sentry.getCurrentHub().getClient()

  if (client) {
    return Promise.resolve(client.close(timeout))
  }

  return Promise.resolve(false)
} */
